import { useMemo } from 'react';

import {
  resolveAccountActionCatalog,
} from '@/lib/navigation/account-action-catalog';
import type {
  AccountActionCatalogContext,
  AccountActionDefinition,
} from '@/lib/navigation/types/account-action-catalog-types';
import { useAccountState } from '@/contexts/account/account-context';

export function useResolvedAccountActionCatalog(): AccountActionDefinition[] {
  const { currentAccount } = useAccountState();
  const isShopifyGateway = currentAccount?.subscription?.paymentGateway === 'shopify';

  const context: AccountActionCatalogContext = useMemo(
    () => ({
      isShopifyGateway,
    }),
    [isShopifyGateway]
  );

  return useMemo(() => resolveAccountActionCatalog(context), [context]);
}

